import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

let requires = [];

interface DropAndTimelineGraphsController {
  description: string;
  formatTime: any;
  timeZoneId: string;
  reportStartDate: Date;
  reportEndDate: Date;

  data: apsViewModels.DropReportDetails;
  prettyDataArray: any[];

  tooltipWorkaround: any;
  getDetailTooltip(e: any): any;

  setData(data: apsViewModels.DropReportDetails): void;
}

class DropAndTimelineGraphsCtrl implements DropAndTimelineGraphsController {
  description: string;
  formatTime: any;
  timeZoneId: string;
  reportStartDate: Date;
  reportEndDate: Date;

  data: apsViewModels.DropReportDetails;
  prettyDataArray: any[];

  tooltipWorkaround: any;

  constructor() {
    this.prettyDataArray = [];

    var vm = this;
    this.tooltipWorkaround = {
      getDetailTooltip: function (e) {
        return vm.getDetailTooltip(e);
      }
    };
  }

  setData(data: apsViewModels.DropReportDetails): void {
    this.data = data;
    this.prettyDataArray = [];

    if (data) {
      // store the pretty data in an array to force recreation of the d3 graphs
      // to work around angular-dimple issues with dynamic data
      this.prettyDataArray.push({
        dropPrettyData: this.transformDropDataPretty(data.dropItems),
        timelinePrettyData: this.transformCavityHistoryDataPretty(data)
      });
    }
  }

  transformDropDataPretty(dropResults: apsViewModels.ReportDetailsDropItem[]): any[] {
    return _.map(dropResults, (dr) => {
      return {
        'Machine Section': dr.machineSection,
        'Drop Name': dr.dropName,
        'Count': dr.count,
        'Section': dr.section,
        'Gob': dr.gobName,
        'Gob Number': dr.gob,
        'OrderBy': (dr.machineNumber * 10000) + (dr.section * 100) + dr.gob
      };
    });
  }

  transformCavityHistoryDataPretty(detailResults: apsViewModels.DropReportDetails): any[] {
    var cavityItems = _.map(detailResults.timelineItems, (defect) => {
      return {
        'Machine Section': defect.machineSection,
        'Drop Name': defect.dropName,
        'Section': defect.section,
        'Gob Number': defect.gob,
        'Time': this.mapDateToSpecifiedTimeZoneToWorkAroundD3Limitations(defect.time),
        'isMoldReject': defect.isMoldReject,
        'Dot Size': defect.isMoldReject ? 15 : 5,
        'Fixed': 1,
        'OrderBy': (defect.machineNumber * 1000) + (defect.section * 10) + defect.gob
      };
    });

    _.forEach(detailResults.dropItems, (di: apsViewModels.ReportDetailsDropItem) => {
      if (_.find(cavityItems, {'Drop Name': di.dropName})) {
        return;
      }
      cavityItems.push({
        'Machine Section': di.machineSection,
        'Drop Name': di.dropName,
        'Section': di.section,
        'Gob Number': di.gob,
        'Time': null,
        'isMoldReject' : null,
        'Dot Size': 0,
        'Fixed': 1,
        'OrderBy': (di.machineNumber * 1000) + (di.section * 10) + di.gob
      });
    });

    return cavityItems;
  }

  calculateTimeZoneOffsetDifference(date: Date): Number {
    if (!this.timeZoneId) {
      return 0;
    }
    var currentOffset = moment(date).utcOffset();
    var offsetInTargetTz = moment(date).tz(this.timeZoneId).utcOffset();
    return offsetInTargetTz - currentOffset;
  }

  mapDateToSpecifiedTimeZoneToWorkAroundD3Limitations(date: Date): Date {
    var offsetDifference = this.calculateTimeZoneOffsetDifference(date);
    if (0 === offsetDifference) {
      return date;
    }

    var fakeMomentInTz = (<any>moment(date)).add(offsetDifference, 'minutes');
    return fakeMomentInTz.toDate();
  }

  mapBackFromSpecifiedTimeZone(date: Date): Date {
    var offsetDifference = this.calculateTimeZoneOffsetDifference(date);
    if (0 === offsetDifference) {
      return date;
    }

    var fakeMomentInTz = (<any>moment(date)).subtract(offsetDifference, 'minutes');
    return fakeMomentInTz.toDate();
  }

  getDetailTooltip(e: any): any {
    if ((e.y.getTime() < this.reportStartDate.getTime())
      || (this.reportEndDate.getTime() < e.y.getTime())) {
      return null;
    }

    var time = this.mapBackFromSpecifiedTimeZone(e.y);
    return ['Gob: ' + e.x,
      'Time: ' + this.formatTime(time)];
  }
}

export default angular.module('aps.controller.dropAndTimelineGraphs', requires)
  .controller('DropAndTimelineGraphsCtrl', DropAndTimelineGraphsCtrl)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/dropAndTimelineGraphs.controller.ts